import { error } from 'services/graphql/fragments/Fragments';
import { AnalyticsEventFragment } from 'services/graphql/fragments/HomeTilesContentFragment';
import { gql } from 'urql';

export const ActivateSelfFundedOffer = gql`
  mutation ActivateSelfFundedOffer($offerId: ID!) {
    activateSelfFundedOffer(offerId: $offerId) {
      __typename
      ... on ActivateSelfFundedOfferSuccess {
        __typename
        id
        isSuccess
        successTitle: title
        subTitle
        activatedOfferId
        displayAnalytics {
          ...AnalyticsEventFragment
        }
        offerDetailsCtaAnalytics {
          ...AnalyticsEventFragment
        }
      }
      ... on ActivateSelfFundedOfferError {
        __typename
        ...error
      }
    }
  }
  ${error}
  ${AnalyticsEventFragment}
`;

export default ActivateSelfFundedOffer;
